export const isCurrentActivePlan = ({ planId, subscription }) => {
  if (!planId || !subscription) return false;

  return (
    Number(subscription.plan_id) === Number(planId) &&
    Number(subscription.subscription_status) === 1
  );
};
